import { PageHeader } from "@/pages/layoutChrome";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import { TramitesEmbeddedPanel } from "@/modules/tramites/embeddedPanels";
import { TRAMITES_CONTEXT_LABEL, TRAMITES_TAB_IDS } from "@/modules/tramites/manifest";

/**
 * Pantalla Trámites — Inscripción trabajadores SAT (permanece en módulo Trámites Fiscales).
 */
export default function TramitesInscripcionTrabajadoresSat() {
  return (
    <div className="space-y-6" data-testid="tramites-inscripcion-trabajadores-sat-page">
      <PageHeader
        title="Inscripción de trabajadores SAT"
        subtitle="Prepare y controle trámites fiscales relacionados con alta o inscripción de trabajadores ante SAT. Esta pantalla pertenece a Trámites Fiscales."
        breadcrumb={[TRAMITES_CONTEXT_LABEL, "Inscripción de trabajadores SAT"]}
      />

      <div className="px-8 max-w-6xl">
        <ModuleClientSelector variant="panel" className="mb-6" />
        <TramitesEmbeddedPanel tabId={TRAMITES_TAB_IDS.INSCRIPCION_SAT} />
      </div>
    </div>
  );
}
